// extracted by mini-css-extract-plugin
export default {"container":"ProductContainer_container__C9+FH","centered":"ProductContainer_centered__-jABZ"};